import type { Feature, FeatureGroup, FeatureModule } from '../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from './group';
import { ACCOUNT_MODULE } from './account';
import { ACTIVITY_MODULE } from './activity';
import { ADMIN_MODULE } from './admin';
import { API_KEYS_MODULE } from './api-keys';
import { ASSETS_MODULE } from './assets';
import { DOMAINS_MODULE } from './domains';
import { NOTIFICATIONS_MODULE } from './notifications';
import { ORGANIZATION_MODULE } from './organization';
import { PRODUCTS_MODULE } from './products';
import { RESOURCES_MODULE } from './resources';
import { ROLES_MODULE } from './roles';
import { SECURITY_MODULE } from './security';
import { TEAM_MODULE } from './team';

export { ADMINISTRATIVE_FEATURE_GROUP } from './group';
export * from './account';
export * from './activity';
export * from './admin';
export * from './api-keys';
export * from './assets';
export * from './domains';
export * from './notifications';
export * from './organization';
export * from './products';
export * from './resources';
export * from './roles';
export * from './security';
export * from './team';

export const ALL_ADMINISTRATIVE_MODULES: FeatureModule[] = [
  ACCOUNT_MODULE,
  ACTIVITY_MODULE,
  ADMIN_MODULE,
  API_KEYS_MODULE,
  ASSETS_MODULE,
  DOMAINS_MODULE,
  NOTIFICATIONS_MODULE,
  ORGANIZATION_MODULE,
  PRODUCTS_MODULE,
  RESOURCES_MODULE,
  ROLES_MODULE,
  SECURITY_MODULE,
  TEAM_MODULE,
];

export const ALL_ADMINISTRATIVE_FEATURE_GROUPS: FeatureGroup[] = [
  ADMINISTRATIVE_FEATURE_GROUP,
  ...ALL_ADMINISTRATIVE_MODULES.flatMap((m) => m.groups),
];

export const ALL_ADMINISTRATIVE_FEATURES: Feature[] = ALL_ADMINISTRATIVE_MODULES.flatMap((m) => m.features);
